import { Text } from '@belong/ui';
import { MaintenanceRecurrenceSubTaskModel } from 'api/models';
import Label from 'components/Label/Label';
import { getStatus } from 'pages/Accounts/Components/maintenance-recurrence/maintenance-recurrence.utils';

type MaintenanceRecurrentHeaderProps = {
  title: string;
  homeAddress?: string;
  // Optional because `maintenance-recurrence-subtask` already passes `undefined`
  // whenever the recurrence has no `repeatFrequencyDays`.
  frequency?: string;
  maintenanceId?: number;
  masterMaintenanceId?: number;
  status?: MaintenanceRecurrenceSubTaskModel['subTaskStatus'];
};

export const MaintenanceRecurrenceHeader = ({
  title,
  homeAddress,
  frequency,
  maintenanceId,
  masterMaintenanceId,
  status,
}: MaintenanceRecurrentHeaderProps) => {
  const statusStyle = getStatus(status);
  return (
    <div className="flex w-full flex-col items-center">
      {homeAddress && (
        <div className="mb-sm flex items-center justify-center gap-2xs text-center">
          <Text variant="p1" className="font-semibold text-dark-gray">
            {`${homeAddress} / Pro Service / ${masterMaintenanceId ? `#${masterMaintenanceId} /` : ''}`}
          </Text>
          {maintenanceId && (
            <Text variant="p1" className="font-semibold text-navy">
              {`#${maintenanceId}`}
            </Text>
          )}
        </div>
      )}

      <h2 className="mb-2sm text-center">{title}</h2>
      <div className="flex items-center justify-center gap-xs text-center">
        <Label text={`Routine | ${frequency}`} />
        {status && (
          <Label text={statusStyle.label} color={statusStyle.labelColor} />
        )}
      </div>
    </div>
  );
};
